import { ISchemaError } from "../interfaces/ISchemaError/ISchemaError";
import { z } from "zod";

export const idSchema = z.string({ invalid_type_error: ISchemaError.ID_INVALID_TYPE }).uuid({ message: ISchemaError.INVALID_GUID });
